import "./Divider20.css"

type Properties = {
    empty?: boolean
}

function Divider20(props: Properties) {
    return <>
        <div className={(props.empty ? "right-panel-divider-empty" : "right-panel-divider")}>_</div>
    </>
}

export default Divider20